import React from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";

const Hero = () => {
  return (
    <>
    <div>
      <section className="hero">
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO Al-Munir Educational System"
              title="An Educational Network Committed to Excellence"
            />
            <p>
              Al-Munir School & Academy stands as a beacon of faith and learning
              — where knowledge enlightens the mind, and values guide the heart.
              Our mission is to cultivate confident, ethical, and visionary
              learners who strive for excellence in both this world and the
              hereafter..
            </p>
          </div>
        </div>
      </section>
      <div className="margin"></div>
    </div>
    </>
  );
};

export default Hero;
